import { library } from '@fortawesome/fontawesome-svg-core'

/**
 * Regular
 * regular icons must have the `far` prefix to avoid conflict with other icons
 */
import {
  faChevronDown as fasChevronDown,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
} from '@fortawesome/pro-solid-svg-icons'

/**
 * Regular
 * regular icons must have the `far` prefix to avoid conflict with other icons
 */
import {
  faQuestionCircle as farQuestionCircle,
  faSearch as farSearch,
  faCheck as farCheck,
  faUserGraduate as farUserGraduate,
  faBars as farBars,
  faTimes as farTimes,
} from '@fortawesome/pro-regular-svg-icons'

/**
 * Light
 * light icons must have the `fal` prefix to avoid conflict with other icons
 */
import {
  faPortrait as falPortrait,
  faFrog as falFrog,
  faDice as falDice,
  faFeather as falFeather,
  faAtomAlt as falAtomAlt,
  faGlobeAmericas as falGlobeAmericas,
  faHourglassHalf as falHourglassHalf,
  faBook as falBook,
  faCommentAlt as falCommentAlt,
  faBookOpen as falBookOpen,
  faCalculator as falCalculator,
  faFont as falFont,
  faFlask as falFlask,
  faFileAlt as falFileAlt,
  faUsers as falUsers,
  faUser as falUser,
  faCheck as falCheck,
  faTimes as falTimes,
  faNewspaper as falNewspaper,
} from '@fortawesome/pro-light-svg-icons'

/**
 * Brand
 * brand icons must have the `fab` prefix to avoid conflict with other icons
 */
import {
  faFacebook as fabFacebook,
  faInstagram as fabInstagram,
  faTwitter as fabTwitter,
  faYoutube as fabYoutube,
} from '@fortawesome/free-brands-svg-icons'

/**
 * Make icons available globally
 */
library.add(
  fabFacebook,
  fabInstagram,
  fabTwitter,
  fabYoutube,
  falAtomAlt,
  falBook,
  falBookOpen,
  falCalculator,
  falCheck,
  falCommentAlt,
  falDice,
  falFeather,
  falFileAlt,
  falFlask,
  falFont,
  falFrog,
  falGlobeAmericas,
  falHourglassHalf,
  falNewspaper,
  falPortrait,
  falUsers,
  falUser,
  falTimes,
  farBars,
  farCheck,
  farQuestionCircle,
  farSearch,
  farTimes,
  farUserGraduate,
  fasChevronDown,
  fasChevronLeft,
  fasChevronRight,
)
